import { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, setDoc, Timestamp, getFirestore } from "firebase/firestore";
import { app } from "./firebase";
import { v4 as uuidv4 } from "uuid";
import emailjs from "emailjs-com";

import "./css/App.css";
import "swiper/swiper-bundle.min.css";

const storage = getStorage();
const db = getFirestore(app);

function validateEmail(mail) {
  if (
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      mail
    )
  ) {
    return true;
  }
  return false;
}

function App() {
  const [secondarySteps, setSecondarySteps] = useState(0);
  const [currentStep, setCurrentStep] = useState(1);
  const [progressWidth, setProgressWidth] = useState(0);
  const [mainSwiper, setMainSwiper] = useState(null);
  const [modalOpacity, setModalOpacity] = useState(0);
  const [modalZIndex, setModalZIndex] = useState(-50);
  const [modalImageSource, setModalImageSource] = useState("");
  const [checkboxIsChecked, setCheckboxIsChecked] = useState(false);
  const [firstSwiper, setFirstSwiper] = useState(null);
  const [secondSwiper, setSecondSwiper] = useState(null);
  const [thirdSwiper, setThirdSwiper] = useState(null);
  const [nextButtonText, setNextButtonText] = useState("Next");
  const [answer5, setAnswer5] = useState(0);
  const [answer6, setAnswer6] = useState(0);
  const [answer7, setAnswer7] = useState(0);
  const [require1Opacity, setRequire1Opacity] = useState(0);
  const [require2Opacity, setRequire2Opacity] = useState(0);
  const [require3Opacity, setRequire3Opacity] = useState(0);
  const [require4Opacity, setRequire4Opacity] = useState(0);
  const [require5Opacity, setRequire5Opacity] = useState(0);
  const [require6Opacity, setRequire6Opacity] = useState(0);
  const [require7Opacity, setRequire7Opacity] = useState(0);
  const [firstNameRequireOpacity, setFirstNameRequireOpacity] = useState(0);
  const [lastNameRequireOpacity, setLastNameRequireOpacity] = useState(0);
  const [emailRequireOpacity, setEmailRequireOpacity] = useState(0);
  const [sketchImage, setSketchImage] = useState([]);
  const [otherFiles, setOtherFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadText, setUploadText] = useState("");
  const [surveyIsStarted, setSurveyIsStarted] = useState(false);
  const [hintIsVisible, setHintIsVisible] = useState(false);

  const sketchImageUploadRef = useRef(null);
  const documentsUploadRef = useRef(null);
  const answer1 = useRef("");
  const answer2 = useRef("");
  const answer3 = useRef("");
  const answer4 = useRef("");
  const answer8 = useRef("");
  const answer9 = useRef("");
  const answer10 = useRef("");
  const firstName = useRef("");
  const lastName = useRef("");
  const email = useRef("");
  const phoneNumber = useRef("");

  function handleNext() {
    setHintIsVisible(false);

    switch (secondarySteps) {
      case 0:
        if (answer1.current === "") {
          setRequire1Opacity(1);
        } else {
          setRequire1Opacity(0);
          firstSwiper.slideNext();
          setSecondarySteps(secondarySteps + 1);
          setProgressWidth((92 / 11) * 1);
        }
        break;
      case 1:
        if (answer2.current === "") {
          setRequire2Opacity(1);
        } else {
          setRequire2Opacity(0);
          mainSwiper.slideNext();
          setProgressWidth((92 / 11) * 2);

          setSecondarySteps(secondarySteps + 1);
          setCurrentStep(currentStep + 1);
        }
        break;
      case 2:
        if (answer3.current === "") {
          setRequire3Opacity(1);
        } else {
          setRequire3Opacity(0);
          secondSwiper.slideNext();
          setSecondarySteps(secondarySteps + 1);
          setProgressWidth((92 / 11) * 3);
        }
        break;

      case 3:
        if (answer4.current === "") {
          setRequire4Opacity(1);
        } else {
          setRequire4Opacity(0);
          mainSwiper.slideNext();
          setProgressWidth((92 / 11) * 4);
          setSecondarySteps(secondarySteps + 1);
          setCurrentStep(currentStep + 1);
        }
        break;

      case 4:
        if (answer5 === 0) {
          setRequire5Opacity(1);
        } else {
          setRequire5Opacity(0);
          thirdSwiper.slideNext();
          setSecondarySteps(secondarySteps + 1);
          setProgressWidth((92 / 11) * 5);
        }
        break;
      case 5:
        if (answer6 === 0) {
          setRequire6Opacity(1);
        } else {
          setRequire6Opacity(0);
          thirdSwiper.slideNext();
          setSecondarySteps(secondarySteps + 1);
          setProgressWidth((92 / 11) * 6);
        }
        break;
      case 6:
        if (answer7 === 0) {
          setRequire7Opacity(1);
        } else {
          setRequire7Opacity(0);
          thirdSwiper.slideNext();
          setSecondarySteps(secondarySteps + 1);
          setProgressWidth((92 / 11) * 7);
        }
        break;
      case 7:
        thirdSwiper.slideNext();
        setSecondarySteps(secondarySteps + 1);
        setProgressWidth((92 / 11) * 8);
        break;

      case 8:
        mainSwiper.slideNext();
        setProgressWidth((92 / 11) * 9);
        setSecondarySteps(secondarySteps + 1);
        setCurrentStep(currentStep + 1);
        break;

      case 9:
        mainSwiper.slideNext();
        setProgressWidth((92 / 11) * 10);
        setSecondarySteps(secondarySteps + 1);
        setCurrentStep(currentStep + 1);
        break;

      case 10:
        mainSwiper.slideNext();
        setProgressWidth(92);
        setSecondarySteps(secondarySteps + 1);
        setCurrentStep(currentStep + 1);
        setNextButtonText("Submit");
        break;

      case 11:
        submitSurvey();
        break;

      default:
        break;
    }
  }

  function handlePrev() {
    setHintIsVisible(false);
    setProgressWidth(progressWidth - 92 / 11);

    switch (secondarySteps) {
      case 1:
        firstSwiper.slidePrev();
        setSecondarySteps(secondarySteps - 1);
        break;
      case 2:
        mainSwiper.slidePrev();
        setCurrentStep(currentStep - 1);
        setSecondarySteps(secondarySteps - 1);
        break;

      case 3:
        secondSwiper.slidePrev();
        setSecondarySteps(secondarySteps - 1);
        break;

      case 4:
        mainSwiper.slidePrev();
        setCurrentStep(currentStep - 1);
        setSecondarySteps(secondarySteps - 1);
        break;

      case 5:
      case 6:
      case 7:
      case 8:
        thirdSwiper.slidePrev();
        setSecondarySteps(secondarySteps - 1);
        break;

      case 9:
        mainSwiper.slidePrev();
        setCurrentStep(currentStep - 1);
        setSecondarySteps(secondarySteps - 1);
        break;

      case 10:
        mainSwiper.slidePrev();
        setCurrentStep(currentStep - 1);
        setSecondarySteps(secondarySteps - 1);
        break;

      case 11:
        mainSwiper.slidePrev();
        setCurrentStep(currentStep - 1);
        setSecondarySteps(secondarySteps - 1);
        setNextButtonText("Next");
        break;

      default:
        break;
    }
  }

  function selectSketch() {
    sketchImageUploadRef.current.click();
  }

  function selectDocuments() {
    documentsUploadRef.current.click();
  }

  function handleCheckbox() {
    checkboxIsChecked
      ? setCheckboxIsChecked(false)
      : setCheckboxIsChecked(true);
  }

  function handleAnswer1(event) {
    answer1.current = event.target.value;
  }

  function handleAnswer2(event) {
    answer2.current = event.target.value;
  }

  function handleAnswer3(event) {
    answer3.current = event.target.value;
  }

  function handleAnswer4(event) {
    answer4.current = event.target.value;
  }

  function handleAnswer8(event) {
    answer8.current = event.target.value;
  }

  function handleAnswer9(event) {
    answer9.current = event.target.value;
  }

  function handleAnswer10(event) {
    answer10.current = event.target.value;
  }

  function handleFirstNameChange(event) {
    firstName.current = event.target.value;
    setFirstNameRequireOpacity(0);
  }

  function handleLastNameChange(event) {
    lastName.current = event.target.value;
    setLastNameRequireOpacity(0);
  }

  function handleEmailChange(event) {
    email.current = event.target.value;
    setEmailRequireOpacity(0);
  }

  function handlePhoneChange(event) {
    phoneNumber.current = event.target.value;
  }

  function sketchFileChange(event) {
    setSketchImage([event.target.files[0]]);
  }

  function otherFilesChange(event) {
    setOtherFiles(Array.from(event.target.files));
  }

  async function submitSurvey() {
    if (firstName.current === "") {
      setFirstNameRequireOpacity(1);
    } else if (lastName.current === "") {
      setLastNameRequireOpacity(1);
    } else if (email.current === "") {
      setEmailRequireOpacity(1);
    } else if (!checkboxIsChecked) {
      alert("In order to proceed, you need to check the checkbox below.");
    } else if (!validateEmail(email.current)) {
      alert("Please enter a valid email address!");
    } else {
      const id = uuidv4();
      const images = [...sketchImage, ...otherFiles];
      let imageUrls = [];
      setIsUploading(true);

      // Uploading images and saving image URLs
      if (images.length) {
        setUploadText("Uploading files");

        for (let i = 0; i < images.length; i++) {
          await uploadBytes(ref(storage, `${id}/${images[i].name}`), images[i])
            .then(async () => {
              await getDownloadURL(ref(storage, `${id}/${images[i].name}`))
                .then((url) => {
                  imageUrls.push(url);
                })
                .catch(() => {
                  alert("Something went wrong, when uploading files");
                  setIsUploading(false);
                });
            })
            .catch(() => {
              alert("Something went wrong, when uploading files");
              setIsUploading(false);
            });
        }
      }

      setUploadText("Uploading answers");

      const docData = {
        answer1: answer1.current,
        answer2: answer2.current,
        answer3: answer3.current,
        answer4: answer4.current,
        answer5: answer5,
        answer6: answer6,
        answer7: answer7,
        answer8: answer8.current,
        answer9: answer9.current,
        answer10: answer10.current,
        contact: {
          firstName: firstName.current,
          lastName: lastName.current,
          email: email.current,
          phoneNumber: phoneNumber.current,
        },
        images: imageUrls,
        date: Timestamp.fromDate(new Date()),
      };

      // Saving data to database
      await setDoc(doc(db, "answers", id), docData)
        .then(() => {
          setUploadText("Data saved");

          const emailParams = {
            firstName: firstName.current,
            lastName: lastName.current,
            surveyId: id,
          };

          emailjs.send(
            "service_c7gnz8g",
            "template_iu7sng5",
            emailParams,
            "user_4z046goqirguW7756xVlt"
          );
        })
        .catch(() => {
          alert("Something went wrong while saving data");
          setIsUploading(false);
          setUploadText("");
        });
    }
  }

  return (
    <div className="App">
      <div className="wrapper">
        <img
          alt="Logo"
          className="logo"
          src={require("./assets/images/logo.png").default}
        />

        <div className="mainContainer">
          <div className="textContainer">
            <span className="surveyTitle">
              Getting started on a software project
            </span>

            <span className="teamText">- The Day Digital Team</span>
          </div>

          {isUploading ? (
            <div class="uploadingContainer">
              {uploadText !== "Data saved" ? (
                <div className="spinnerContainer">
                  <div className="spinner">
                    <div className="dot1"></div>
                    <div className="dot2"></div>
                  </div>
                  <span className="progressText">{uploadText}</span>
                </div>
              ) : (
                <div className="doneContainer">
                  <img
                    alt=""
                    src={require("./assets/images/done.svg").default}
                    width="30vw"
                  />
                  <span className="doneText">DONE</span>
                </div>
              )}
            </div>
          ) : surveyIsStarted ? (
            <div className="surveyContainer">
              <div
                className="progress"
                style={{ width: `${progressWidth}%` }}
              ></div>
              <span className="stepNumbers">
                {Number.parseFloat((secondarySteps * 100) / 11).toFixed(0)}%
              </span>

              <Swiper
                className="mainSwiper"
                onSwiper={setMainSwiper}
                allowTouchMove={false}
              >
                {/* First question */}
                <SwiperSlide className="mainSlide">
                  <span className="mainQuestion">
                    Why are we doing this project?
                  </span>

                  <Swiper
                    className="secondarySwiper"
                    onSwiper={setFirstSwiper}
                    allowTouchMove={false}
                  >
                    <SwiperSlide className="secondarySlide">
                      <div className="questionAndHint">
                        <span className="secondaryQuestionTitle">
                          What is the problem you are trying to solve?
                          <span className="required">*</span>
                          <span
                            className="requiredError"
                            style={{ opacity: require1Opacity }}
                          >
                            Required
                          </span>
                        </span>

                        <img
                          className="tooltipButton"
                          alt=""
                          src={require("./assets/images/tooltip.svg").default}
                          onClick={() =>
                            hintIsVisible
                              ? setHintIsVisible(false)
                              : setHintIsVisible(true)
                          }
                        />

                        <div
                          className="tooltipContainer"
                          style={{
                            opacity: hintIsVisible ? 1 : 0,
                            zIndex: hintIsVisible ? 50 : -50,
                          }}
                        >
                          <div className="tooltipInner">
                            <span className="secondaryQuestionDescription">
                              Wrong answer: "We need cool charts on a mobile
                              app"
                              <br />
                              Right: "We're losing clients because we do reports
                              manually, they're expensive and outdated compared
                              to the competition"
                            </span>
                          </div>
                          <div
                            className="tooltipCloseButton"
                            onClick={() =>
                              hintIsVisible
                                ? setHintIsVisible(false)
                                : setHintIsVisible(true)
                            }
                          >
                            <img
                              alt=""
                              src={
                                require("./assets/images/tooltipCloseButton.svg")
                                  .default
                              }
                              width="100%"
                            />
                          </div>
                        </div>
                      </div>

                      <textarea
                        className="textAreaAnswer"
                        placeholder="Your answer"
                        onChange={handleAnswer1}
                      />
                    </SwiperSlide>

                    <SwiperSlide className="secondarySlide">
                      <div className="questionAndHint">
                        <span className="secondaryQuestionTitle">
                          What happens now?<span className="required">*</span>
                          <span
                            className="requiredError"
                            style={{ opacity: require2Opacity }}
                          >
                            Required
                          </span>
                        </span>

                        <img
                          className="tooltipButton"
                          alt=""
                          src={require("./assets/images/tooltip.svg").default}
                          onClick={() =>
                            hintIsVisible
                              ? setHintIsVisible(false)
                              : setHintIsVisible(true)
                          }
                        />

                        <div
                          className="tooltipContainer"
                          style={{
                            opacity: hintIsVisible ? 1 : 0,
                            zIndex: hintIsVisible ? 50 : -50,
                          }}
                        >
                          <div className="tooltipInner">
                            <span className="secondaryQuestionDescription">
                              e.g. How do people do things today/get around the
                              problem.
                            </span>
                          </div>

                          <div
                            className="tooltipCloseButton"
                            onClick={() =>
                              hintIsVisible
                                ? setHintIsVisible(false)
                                : setHintIsVisible(true)
                            }
                          >
                            <img
                              alt=""
                              src={
                                require("./assets/images/tooltipCloseButton.svg")
                                  .default
                              }
                              width="100%"
                            />
                          </div>
                        </div>
                      </div>

                      <textarea
                        className="textAreaAnswer"
                        placeholder="Your answer"
                        onChange={handleAnswer2}
                      />
                    </SwiperSlide>
                  </Swiper>
                </SwiperSlide>

                {/* Second question */}
                <SwiperSlide className="mainSlide">
                  <span className="mainQuestion">
                    What will success look like?
                  </span>

                  <Swiper
                    className="secondarySwiper"
                    onSwiper={setSecondSwiper}
                    allowTouchMove={false}
                  >
                    <SwiperSlide className="secondarySlide">
                      <div className="questionAndHint">
                        <span className="secondaryQuestionTitle">
                          When this product launches what will be happening?
                          <span className="required">*</span>
                          <span
                            className="requiredError"
                            style={{ opacity: require3Opacity }}
                          >
                            Required
                          </span>
                        </span>

                        <img
                          className="tooltipButton"
                          alt=""
                          src={require("./assets/images/tooltip.svg").default}
                          onClick={() =>
                            hintIsVisible
                              ? setHintIsVisible(false)
                              : setHintIsVisible(true)
                          }
                        />

                        <div
                          className="tooltipContainer"
                          style={{
                            opacity: hintIsVisible ? 1 : 0,
                            zIndex: hintIsVisible ? 50 : -50,
                          }}
                        >
                          <div className="tooltipInner">
                            <span className="secondaryQuestionDescription">
                              Each client is different - 'customers are buying
                              coffee using our app' 'everyone in the company is
                              recording audio statuses once a day' 'our finance
                              team is producing reports, relevant people get
                              notified via an app'
                            </span>
                          </div>

                          <div
                            className="tooltipCloseButton"
                            onClick={() =>
                              hintIsVisible
                                ? setHintIsVisible(false)
                                : setHintIsVisible(true)
                            }
                          >
                            <img
                              alt=""
                              src={
                                require("./assets/images/tooltipCloseButton.svg")
                                  .default
                              }
                              width="100%"
                            />
                          </div>
                        </div>
                      </div>

                      <textarea
                        className="textAreaAnswer"
                        placeholder="Your answer"
                        onChange={handleAnswer3}
                      />
                    </SwiperSlide>

                    <SwiperSlide className="secondarySlide">
                      <div className="questionAndHint">
                        <span className="secondaryQuestionTitle">
                          Please rank the key users of the app
                          <span className="required">*</span>
                          <span
                            className="requiredError"
                            style={{ opacity: require4Opacity }}
                          >
                            Required
                          </span>
                        </span>

                        <img
                          className="tooltipButton"
                          alt=""
                          src={require("./assets/images/tooltip.svg").default}
                          onClick={() =>
                            hintIsVisible
                              ? setHintIsVisible(false)
                              : setHintIsVisible(true)
                          }
                        />

                        <div
                          className="tooltipContainer"
                          style={{
                            opacity: hintIsVisible ? 1 : 0,
                            zIndex: hintIsVisible ? 50 : -50,
                          }}
                        >
                          <div className="tooltipInner">
                            <span className="secondaryQuestionDescription">
                              e.g. 1. Our sales team 2. External clients 3.
                              Finance team/admin users 4. Our board of directors
                            </span>
                          </div>

                          <div
                            className="tooltipCloseButton"
                            onClick={() =>
                              hintIsVisible
                                ? setHintIsVisible(false)
                                : setHintIsVisible(true)
                            }
                          >
                            <img
                              alt=""
                              src={
                                require("./assets/images/tooltipCloseButton.svg")
                                  .default
                              }
                              width="100%"
                            />
                          </div>
                        </div>
                      </div>

                      <textarea
                        className="textAreaAnswer"
                        placeholder="Your answer"
                        onChange={handleAnswer4}
                      />
                    </SwiperSlide>
                  </Swiper>
                </SwiperSlide>

                {/* Third question */}
                <SwiperSlide className="mainSlide">
                  <span className="mainQuestion">'Look and feel'</span>

                  <span>What do you think of these?</span>

                  <Swiper
                    className="secondarySwiper"
                    onSwiper={setThirdSwiper}
                    allowTouchMove={false}
                  >
                    <SwiperSlide className="secondarySlide">
                      <span className="secondaryQuestionTitle marginT5">
                        Fun and playful<span className="required">*</span>
                      </span>

                      <div className="imageContainer">
                        <img
                          alt=""
                          className="img"
                          src={
                            require("./assets/images/funAndPlayful.jpg").default
                          }
                        />
                      </div>

                      <div className="ratingContainer">
                        <span
                          className="requiredError"
                          style={{ opacity: require5Opacity, top: "-24%" }}
                        >
                          Required
                        </span>
                        <div className="ratings">
                          <div
                            className="rating rating1"
                            style={{
                              backgroundColor:
                                answer5 === 1 ? "#ff0033" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer5(1)}
                          >
                            <span>A</span>
                          </div>
                          <div
                            className="rating rating2"
                            style={{
                              backgroundColor:
                                answer5 === 2 ? "#ff5f7f" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer5(2)}
                          >
                            <span>B</span>
                          </div>
                          <div
                            className="rating rating3"
                            style={{
                              backgroundColor:
                                answer5 === 3 ? "#94b49b" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer5(3)}
                          >
                            <span>C</span>
                          </div>
                          <div
                            className="rating rating4"
                            style={{
                              backgroundColor:
                                answer5 === 4 ? "#68cd7f" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer5(4)}
                          >
                            <span>D</span>
                          </div>
                          <div
                            className="rating rating5"
                            style={{
                              backgroundColor:
                                answer5 === 5 ? "#4ccd6a" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer5(5)}
                          >
                            <span>E</span>
                          </div>
                        </div>
                        <div className="ratingsText">
                          <span>Really dislike</span>
                          <span>Really like</span>
                        </div>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide className="secondarySlide">
                      <span className="secondaryQuestionTitle marginT5">
                        Professional
                        <span className="required">*</span>
                      </span>

                      <div className="imageContainer">
                        <img
                          alt=""
                          className="img"
                          src={
                            require("./assets/images/professional.jpg").default
                          }
                        />
                      </div>

                      <div className="ratingContainer">
                        <span
                          className="requiredError"
                          style={{ opacity: require6Opacity, top: "-24%" }}
                        >
                          Required
                        </span>
                        <div className="ratings">
                          <div
                            className="rating rating1"
                            style={{
                              backgroundColor:
                                answer6 === 1 ? "#ff0033" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer6(1)}
                          >
                            <span>A</span>
                          </div>
                          <div
                            className="rating rating2"
                            style={{
                              backgroundColor:
                                answer6 === 2 ? "#ff5f7f" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer6(2)}
                          >
                            <span>B</span>
                          </div>
                          <div
                            className="rating rating3"
                            style={{
                              backgroundColor:
                                answer6 === 3 ? "#94b49b" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer6(3)}
                          >
                            <span>C</span>
                          </div>
                          <div
                            className="rating rating4"
                            style={{
                              backgroundColor:
                                answer6 === 4 ? "#68cd7f" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer6(4)}
                          >
                            <span>D</span>
                          </div>
                          <div
                            className="rating rating5"
                            style={{
                              backgroundColor:
                                answer6 === 5 ? "#4ccd6a" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer6(5)}
                          >
                            <span>E</span>
                          </div>
                        </div>
                        <div className="ratingsText">
                          <span>Really dislike</span>
                          <span>Really like</span>
                        </div>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide className="secondarySlide">
                      <span className="secondaryQuestionTitle marginT5">
                        Get it working, it can look nice later
                        <span className="required">*</span>
                      </span>

                      <div className="imageContainer">
                        <img
                          alt=""
                          className="img"
                          src={
                            require("./assets/images/getItWorking.png").default
                          }
                        />
                      </div>

                      <div className="ratingContainer">
                        <span
                          className="requiredError"
                          style={{ opacity: require7Opacity, top: "-24%" }}
                        >
                          Required
                        </span>
                        <div className="ratings">
                          <div
                            className="rating rating1"
                            style={{
                              backgroundColor:
                                answer7 === 1 ? "#ff0033" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer7(1)}
                          >
                            <span>A</span>
                          </div>
                          <div
                            className="rating rating2"
                            style={{
                              backgroundColor:
                                answer7 === 2 ? "#ff5f7f" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer7(2)}
                          >
                            <span>B</span>
                          </div>
                          <div
                            className="rating rating3"
                            style={{
                              backgroundColor:
                                answer7 === 3 ? "#94b49b" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer7(3)}
                          >
                            <span>C</span>
                          </div>
                          <div
                            className="rating rating4"
                            style={{
                              backgroundColor:
                                answer7 === 4 ? "#68cd7f" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer7(4)}
                          >
                            <span>D</span>
                          </div>
                          <div
                            className="rating rating5"
                            style={{
                              backgroundColor:
                                answer7 === 5 ? "#4ccd6a" : "rgba(0,0,0,0.4)",
                            }}
                            onClick={() => setAnswer7(5)}
                          >
                            <span>E</span>
                          </div>
                        </div>
                        <div className="ratingsText">
                          <span>Really dislike</span>
                          <span>Really like</span>
                        </div>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide className="secondarySlide">
                      <span className="secondaryQuestionTitle marginT5">
                        Additional comments (optional)
                      </span>

                      <textarea
                        className="textAreaAnswer"
                        placeholder="Your answer"
                        onChange={handleAnswer8}
                      />
                    </SwiperSlide>

                    <SwiperSlide className="secondarySlide">
                      <span className="secondaryQuestionTitle marginT5">
                        Got something in mind? (optional)
                      </span>

                      <span className="secondaryQuestionDescription">
                        Please give details/links to any apps, products,
                        websites that you like.
                      </span>

                      <textarea
                        className="textAreaAnswer"
                        placeholder="Your answer"
                        onChange={handleAnswer9}
                      />
                    </SwiperSlide>
                  </Swiper>
                </SwiperSlide>

                {/* Fourth question */}
                <SwiperSlide className="mainSlide">
                  <span className="mainQuestion">Sketches</span>

                  <Swiper className="secondarySwiper" allowTouchMove={false}>
                    <SwiperSlide className="secondarySlide">
                      <span
                        className="secondaryQuestionDescription"
                        style={{ marginTop: "1%" }}
                      >
                        Grab a pen/pencil and an A4 sheet of paper.
                      </span>

                      <span
                        className="secondaryQuestionDescription"
                        style={{ marginTop: "1%" }}
                      >
                        Fold the A4 paper in half (side to side), fold again
                        (top to bottom), and once more (side to side),{" "}
                        <span
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={() => {
                            setModalImageSource(
                              require("./assets/images/foldedPaper.jpg").default
                            );
                            setModalOpacity(1);
                            setModalZIndex(50);
                          }}
                        >
                          leaving 8 squares.
                        </span>
                      </span>

                      <span
                        className="secondaryQuestionDescription"
                        style={{ marginTop: "1%" }}
                      >
                        Set a timer for 8 minutes, and sketch out what this
                        project might look like if it were a mobile app.
                      </span>

                      <span className="secondaryQuestionDescription">
                        Please try this exercise even if your project is web
                        based. This exercise encourages simplicity, max 8
                        screens for now.
                      </span>

                      <div
                        className="uploadButton"
                        onClick={() => selectSketch()}
                      >
                        <span>Upload</span>
                        <input
                          type="file"
                          id="file"
                          ref={sketchImageUploadRef}
                          style={{ display: "none" }}
                          accept="image/*, text/*"
                          onChange={sketchFileChange}
                        />
                      </div>

                      <span className="secondaryQuestionDescription">
                        {sketchImage.length ? sketchImage[0].name : null}
                      </span>

                      <span
                        className="secondaryQuestionDescription"
                        style={{
                          cursor: "pointer",
                          marginTop: 0,
                          textDecoration: "underline",
                        }}
                        onClick={() => {
                          setModalImageSource(
                            require("./assets/images/sketchExample.jpg").default
                          );
                          setModalOpacity(1);
                          setModalZIndex(50);
                        }}
                      >
                        (Example)
                      </span>
                    </SwiperSlide>
                  </Swiper>
                </SwiperSlide>

                {/* Fifth question */}
                <SwiperSlide className="mainSlide">
                  <span className="mainQuestion">Anything else?</span>

                  <Swiper className="secondarySwiper" allowTouchMove={false}>
                    <SwiperSlide className="secondarySlide">
                      <span
                        className="secondaryQuestionDescription"
                        style={{ marginTop: "1%" }}
                      >
                        Existing materials for this project (e.g. designs,
                        documents, list of requirements) even if outdated.
                      </span>

                      <span
                        className="secondaryQuestionDescription"
                        style={{ marginTop: "1%" }}
                      >
                        Upload documents here:
                      </span>

                      <div
                        className="uploadButton"
                        onClick={() => selectDocuments()}
                      >
                        <span>Upload</span>
                        <input
                          type="file"
                          id="file"
                          ref={documentsUploadRef}
                          style={{ display: "none" }}
                          accept="image/*, text/*"
                          multiple
                          onChange={otherFilesChange}
                        />
                      </div>

                      {otherFiles.length === 0
                        ? null
                        : otherFiles.map((file) => {
                            return (
                              <span className="secondaryQuestionDescription">
                                {file.name}
                              </span>
                            );
                          })}

                      <span
                        className="secondaryQuestionDescription"
                        style={{ marginTop: "1%" }}
                      >
                        Any other comments? (optional)
                      </span>

                      <textarea
                        className="textAreaAnswer"
                        placeholder="Your answer"
                        onChange={handleAnswer10}
                      />
                    </SwiperSlide>
                  </Swiper>
                </SwiperSlide>

                {/* Sixth question */}
                <SwiperSlide className="mainSlide">
                  <span className="mainQuestion">
                    Please fill with your details
                  </span>

                  <div className="textInputContainer">
                    <input
                      type="text"
                      required
                      onChange={handleFirstNameChange}
                    />
                    <div className="placeholder">
                      First Name<span>*</span>
                    </div>

                    <span
                      className="requiredError"
                      style={{ opacity: firstNameRequireOpacity, top: "-50%" }}
                    >
                      Required
                    </span>
                  </div>

                  <div className="textInputContainer">
                    <input
                      type="text"
                      required
                      onChange={handleLastNameChange}
                    />
                    <div className="placeholder">
                      Last Name<span>*</span>
                    </div>

                    <span
                      className="requiredError"
                      style={{ opacity: lastNameRequireOpacity, top: "-50%" }}
                    >
                      Required
                    </span>
                  </div>

                  <div className="textInputContainer">
                    <input type="text" required onChange={handleEmailChange} />
                    <div className="placeholder">
                      Your Email<span>*</span>
                    </div>

                    <span
                      className="requiredError"
                      style={{ opacity: emailRequireOpacity, top: "-50%" }}
                    >
                      Required
                    </span>
                  </div>

                  <div className="textInputContainer">
                    <input
                      type="tel"
                      placeholder="Telephone"
                      onChange={handlePhoneChange}
                    />
                  </div>

                  <div className="termsContainer">
                    <div
                      className="checkboxContainer"
                      style={{
                        color: checkboxIsChecked ? "black" : "transparent",
                        backgroundColor: checkboxIsChecked
                          ? "white"
                          : "rgba(0,0,0,0.4)",
                      }}
                      onClick={() => handleCheckbox()}
                    >
                      <span>✔</span>
                    </div>

                    <span className="termsText">
                      The collected data will be used to communicate with you.
                      <span className="required">*</span>
                    </span>
                  </div>
                </SwiperSlide>
              </Swiper>

              {secondarySteps !== 0 ? (
                <div className="prevButton" onClick={() => handlePrev()}>
                  <span>Previous</span>
                </div>
              ) : null}

              <div className="nextButton" onClick={() => handleNext()}>
                <span>{nextButtonText}</span>
              </div>
            </div>
          ) : (
            <div className="surveyStartContainer">
              <span className="surveyDescription">
                Most people over complicate software projects, we like to keep
                things simple. Let's kick start the process...
              </span>

              <div
                className="startButton"
                onClick={() => setSurveyIsStarted(true)}
              >
                Start
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className="imageModal"
        style={{ opacity: modalOpacity, zIndex: modalZIndex }}
      >
        <div className="closeButtonContainer">
          <img
            alt=""
            className="closeIcon"
            src={require("./assets/images/close_icon.svg").default}
            onClick={() => {
              setModalOpacity(0);
              setModalZIndex(-50);
              setModalImageSource("");
            }}
          />
        </div>

        <img alt="" className="modalImg" src={modalImageSource} />
      </div>
    </div>
  );
}

export default App;
